var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import authentication from "@irati/auth";
import CreateRoomAnonChat from "@irati/insights/apollo/mutation/Chatroom/CreateRoom";
import CreateMessageAnonChat from "@irati/insights/apollo/mutation/Chatroom/CreateMessage";
import history from "@irati/utils/history";
import { AddMessage } from "./";
import MessageSent from "./MessageSent";
var NewMessage = /** @class */ (function (_super) {
    __extends(NewMessage, _super);
    function NewMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { text: "", submitted: false };
        _this.handleClear = function () {
            _this.setSubmitted(false);
        };
        _this.setSubmitted = function (submitted) {
            if (submitted === void 0) { submitted = true; }
            _this.setState({ text: "", submitted: submitted });
        };
        _this.handleChange = function (text) {
            _this.setState({ text: text });
        };
        _this.handleNewMessage = function () {
            _this.setSubmitted(false);
        };
        _this.handleGoBack = function () {
            if (authentication.isGlobalAdmin()) {
                history.goBack();
            }
            else {
                history.push("/");
            }
        };
        return _this;
    }
    NewMessage.prototype.render = function () {
        var _this = this;
        var _a = this.props, isUserAnonymous = _a.isUserAnonymous, commentId = _a.commentId, roomUuid = _a.roomUuid, location = _a.location;
        var _b = this.state, text = _b.text, submitted = _b.submitted;
        var user = !isUserAnonymous ? authentication.user() : null;
        return (React.createElement(React.Fragment, null,
            React.createElement(CreateMessageAnonChat, { isUserAnonymous: isUserAnonymous, roomUuid: roomUuid, text: text, onCompleted: function (_a) {
                    var createInsMessage = _a.createInsMessage;
                    if (!roomUuid)
                        history.replace({ pathname: "" + location.pathname + createInsMessage.roomUuid, search: "" });
                    _this.setSubmitted();
                } }, function (createMessage, _a) {
                var messageLoading = _a.loading;
                return (React.createElement(CreateRoomAnonChat, { commentId: commentId, onCompleted: function (_a) {
                        var uuid = _a.createInsRoom.uuid;
                        createMessage({ variables: { params: { roomUuid: uuid } } });
                    } }, function (createRoom, _a) {
                    var roomLoading = _a.loading;
                    var handleCreateMessage = function () {
                        if (!roomUuid)
                            return createRoom();
                        return createMessage();
                    };
                    return submitted ? (React.createElement(MessageSent, { onNewMessage: _this.handleNewMessage, onGoBack: _this.handleGoBack })) : (React.createElement(AddMessage, { text: text, user: user, onSubmit: handleCreateMessage, onChange: _this.handleChange, onCancel: _this.handleClear, loading: !roomUuid && (roomLoading || messageLoading) }));
                }));
            })));
    };
    return NewMessage;
}(Component));
export default withRouter(NewMessage);
